module.exports = __webpack_public_path__ + "img/08a3c17.jpg";